import React from "react";
import { motion } from "framer-motion";
import { FaGamepad, FaServer, FaExchangeAlt, FaWallet } from "react-icons/fa";

const Gaming = () => {
  return (
    <section
      id="gaming"
      className="py-12 px-4 bg-cover bg-center relative"
    >
      <div className="absolute inset-0 bg-black bg-opacity-60"></div>

      <div className="relative max-w-6xl mx-auto">
        <motion.h2
          className="text-3xl font-bold text-red-600 mb-6 text-center flex items-center justify-center space-x-3 border-b-4 border-yellow-400 inline-block"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <FaGamepad className="text-yellow-400 text-5xl" />
          <span>Menelik in Gaming</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="p-6 bg-black bg-opacity-50 rounded-lg shadow-md backdrop-blur-md flex items-start space-x-6 border-l-4 border-red-600"
          >
            <FaServer className="text-yellow-400 text-5xl" />
            <div>
              <p className="text-gray-200 mb-4">
                Menelik seamlessly integrates into gaming, allowing players to earn, 
                spend, or trade <strong className="text-red-400">MENEL</strong> within the game effortlessly, 
                thanks to specialized gaming nodes and communication via <strong className="text-yellow-400">RPC</strong>.
              </p>
              <h4 className="font-semibold text-lg text-yellow-400">Technical Infrastructure</h4>
              <ul className="list-disc ml-4 mt-2 text-gray-300">
                <li><strong>Gaming Node</strong>: Interface between the blockchain and game servers.</li>
                <li><strong>Processing Server API</strong>: Manages transactions and events.</li>
                <li><strong>Game Client</strong>: Reflects player actions on the blockchain.</li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="p-6 bg-black bg-opacity-50 rounded-lg shadow-md backdrop-blur-md flex items-start space-x-6 border-l-4 border-yellow-500"
          >
            <FaExchangeAlt className="text-red-500 text-5xl" />
            <div>
              <h4 className="font-semibold text-lg mb-2 text-yellow-400">Fast and Secure Transactions</h4>
              <p className="text-gray-200">
                With Menelik, in-game transactions are processed quickly and securely, 
                enhancing the gaming experience and enabling efficient handling of rewards, 
                purchases, and other transactions.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="p-6 bg-black bg-opacity-50 rounded-lg shadow-md backdrop-blur-md flex items-start space-x-6 border-l-4 border-red-600"
          >
            <FaWallet className="text-yellow-400 text-5xl" />
            <div>
              <h4 className="font-semibold text-lg mb-2 text-red-400">Games Integrated into the Wallet</h4>
              <p className="text-gray-200">
                The wallet service, in addition to offering standard storage and transaction 
                features, integrates a vast collection of games, simplifying access and 
                unifying services into a powerful web wallet.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="p-6 bg-black bg-opacity-50 rounded-lg shadow-md backdrop-blur-md flex items-start space-x-6 border-l-4 border-yellow-500"
          >
            <FaWallet className="text-red-500 text-5xl" />
            <div>
              <h4 className="font-semibold text-lg mb-2 text-yellow-400">Efficient Balance Between Scarcity and Reward</h4>
              <p className="text-gray-200">
                The wallet incorporates an advanced ecosystem of distribution, burning, and rewards, designed 
                to reduce supply while simultaneously benefiting users, achieving an efficient balance between scarcity and compensation.
              </p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Gaming;
